import RestService from './RestService'

export default class WebsiteTemplateService extends RestService {
    constructor() {
        super('website-templates')
    }

    // createApp(appTemplateId) {
    //     return new Promise((resolve, reject) => {
    //         this.http.get('/api/v1/templates/' + appTemplateId + '/app?t=' + Date.now())
    //             .set('x-api-token', this.authToken)
    //             .set('Accept', 'application/json')
    //             .end((error, response) => {
    //                 if (response.status === 200 || response.status === 201) {
    //                     resolve(JSON.parse(response.text))
    //                 } else {
    //                     reject(response.statusText)
    //                 }
    //             })
    //     })
    // }
}